import { Component } from '@angular/core';

@Component({
  selector: 'app-contact-sales-skeleton-loader',
  templateUrl: './contact-sales-skeleton-loader.component.html',
  standalone: false,
})
export class ContactSalesSkeletonLoaderComponent {}
